import { render, staticRenderFns } from "./herbal.vue?vue&type=template&id=f56dc1fe"
import script from "./herbal.vue?vue&type=script&lang=js"
export * from "./herbal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports